<template>
  <b-navbar class="d-md-flex navbar-expand-lg">
    <b-container>
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
      <b-navbar-brand href="#" to="/" class="mr-auto">Codeimg</b-navbar-brand>
      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav>
          <b-nav-item to="home"
            ><font-awesome-icon
              :icon="['fal', 'home']"
              size="lg"
              fixed-width
            />Home</b-nav-item
          >
          <b-nav-item to="editor">Editor</b-nav-item>
          <b-nav-item to="home">Features</b-nav-item>
          <b-nav-item to="home">About</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-container>
  </b-navbar>
</template>

<script>
export default {
  name: "navigation"
};
</script>
<style></style>
